import React from 'react';
import {useTranslation} from 'react-i18next';

import {SettingsPanel} from '@pexip/media-components';
import {ThemeProvider, ToggleSwitch} from '@pexip/components';

import {SettingsActionsRow} from '../../components/SettingsActionsRow';

import {TestId} from '../../../test/testIds';

export const AccessibilitySettingsView: React.FC<{
    alwaysDisplayUIInterfaces: boolean;
    toggleAlwaysDisplayUIInterfaces: () => void;
    amIApiParticipant: boolean;
    disableKeyboardShortcuts: boolean;
    toggleDisableKeyboardShortcuts: () => void;
}> = ({
    alwaysDisplayUIInterfaces,
    toggleAlwaysDisplayUIInterfaces,
    amIApiParticipant,
    disableKeyboardShortcuts,
    toggleDisableKeyboardShortcuts,
}) => {
    const {t} = useTranslation();

    return (
        <SettingsPanel>
            <ThemeProvider colorScheme="light">
                {!amIApiParticipant && (
                    <SettingsActionsRow
                        title={t(
                            'settings.always-display-ui-controls',
                            'Always display call controls',
                        )}
                        subtitle={t(
                            'settings.always-display-ui-controls-desc',
                            'Call controls will remain in view at all times and will not fade away even after a few seconds of inactivity.',
                        )}
                    >
                        <div style={{paddingInlineStart: '50px'}}>
                            <ToggleSwitch
                                onChange={toggleAlwaysDisplayUIInterfaces}
                                labelModifier="hidden"
                                label={t(
                                    'settings.always-display-ui-controls',
                                    'Always display call controls',
                                )}
                                name="always-display-ui-controls-toggle"
                                data-testid={
                                    TestId.ToggleAlwaysDisplayUiControls
                                }
                                checked={alwaysDisplayUIInterfaces}
                            />
                        </div>
                    </SettingsActionsRow>
                )}
                <SettingsActionsRow
                    title={t(
                        'settings.disable-app-shotcuts',
                        'Disable app shortcuts',
                    )}
                    subtitle={t(
                        'settings.disable-app-shotcuts-desc',
                        'Recommended when using screen readers.',
                    )}
                >
                    <div style={{paddingInlineStart: '50px'}}>
                        <ToggleSwitch
                            onChange={toggleDisableKeyboardShortcuts}
                            labelModifier="hidden"
                            label={t(
                                'settings.disable-app-shotcuts',
                                'Disable app shortcuts',
                            )}
                            name="enable-keyboard-shortcuts-toggle"
                            data-testid={TestId.ToggleDisableKeyboardShortcuts}
                            checked={disableKeyboardShortcuts}
                        />
                    </div>
                </SettingsActionsRow>
            </ThemeProvider>
        </SettingsPanel>
    );
};

export type AccessibilitySettingsViewProps = React.ComponentProps<
    typeof AccessibilitySettingsView
>;
